<div *ngIf="!productUrl">
	<span>{{ params?.value?.formattedValue }}</span>
</div>

<div *ngIf="productUrl && !isFundIdea">
	<ng-container *ngTemplateOutlet="link"></ng-container>
</div>

<div *ngIf="productUrl && isFundIdea">
	<div custom-tracking [track-event]="fundIdeaTrackingString">
		<ng-container *ngTemplateOutlet="link"></ng-container>
	</div>
</div>

<ng-template #link>
	<a class="link-cell text-bold" target="_blank" [href]="productUrl">
		{{ params?.value?.formattedValue }}
	</a>
</ng-template>
